import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiCopy, FiCheck, FiShare2 } from "react-icons/fi";

/** Read-only link with copy (and native share on mobile). */
export default function CopyLink({ url, shareTitle }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  return (
    <div className="shr-linkbox">
      <span className="shr-linkbox-url" title={url}>{url}</span>
      {navigator.share && (
        <button
          type="button"
          className="shr-btn ghost sm"
          onClick={() => navigator.share({ title: shareTitle, url }).catch(() => {})}
          aria-label={t("share.link.share")}
        >
          <FiShare2 size={14} />
        </button>
      )}
      <button type="button" className="shr-btn primary sm" onClick={copy}>
        {copied ? <FiCheck size={14} /> : <FiCopy size={14} />}
        {copied ? t("share.link.copied") : t("share.link.copy")}
      </button>
    </div>
  );
}
